// Stub file - client management functionality removed (was using Supabase)
// All client data should come from backend API endpoints

export function useUnifiedClientManagement() {
  return {
    clients: [],
    isLoading: false,
    error: null,
    fetchClients: async () => {},
    searchClients: async () => [],
    getClientById: async () => null,
  };
}

export function useUnifiedClientCustomers() {
  return {
    customers: [],
    isLoading: false,
    error: null,
    fetchCustomers: async () => {},
  };
}

export function useUnifiedClientStats() {
  return {
    stats: null,
    isLoading: false,
    error: null,
  };
}

export function useUnifiedServiceHealth() {
  return {
    isHealthy: true,
    isLoading: false,
    error: null,
  };
}